<script lang="ts">
    
    import { onMount } from "svelte";
    import { Button, Icon, Spinner } from "sveltestrap";
    import type { Message } from "../../Model/Message";
    import { State } from "../../Model/State";
    import { messagesFactory, messagesService } from "../../Services";
    import { i18n } from "../../Services/i18n";
    import Watch from "../Watch.svelte";

    type MessageItem = {
        message: Message;
        isSaving: State<boolean>;
    };

    export let roomId: string;

    let timeout;
    let messageItems: MessageItem[] = [];

    onMount(mount);

    async function mount(): Promise<void> {
        const messages = await messagesService.getRoomMessages(roomId);
        messageItems = messages.map(createMessageItem);
    }

    function addMessage(): void {
        const message = messagesFactory.create(roomId);
        const messageItem = createMessageItem(message);
        messageItems = [...messageItems, messageItem];
    }

    async function saveMessage(messageItem: MessageItem): Promise<void> {
        if (messageItem.isSaving.value) {
            return;
        }
        try {
            messageItem.isSaving.set(true);
            await messagesService.save(messageItem.message);
        } catch (error) {
            console.error(error);
        } finally {
            messageItem.isSaving.set(false);
        }
    }
    
    async function removeMessage(messageItem: MessageItem): Promise<void> {
        if (!confirm('¿Seguro que quieres eliminar este mensaje?')) {
            return;
        }
        try {
            await messagesService.deleteMessage(messageItem.message.id);
            messageItems = messageItems.filter(({ message }) => message.id !== messageItem.message.id);
        } catch (error) {
            console.error(error);
        }
    }

    function debounceSaveMessage(messageItem) {
        if (timeout) {
            clearTimeout(timeout);
        }

        timeout = setTimeout(() => {
            saveMessage(messageItem);
        }, 3000);
    }

    function createMessageItem(message: Message): MessageItem {
        return {
            message,
            isSaving: new State(false),
        };
    }

</script>

<div class="messages">
    {#each messageItems as messageItem, index}
        <Watch state={messageItem.isSaving} let:value={isSaving}>
            <div class="input-group">
                <div class="input-group-text">
                    <input class="form-check-input mt-0" type="checkbox" bind:checked={messageItem.message.enabled.value} on:change={() => saveMessage(messageItem)}>
                  </div>
                <input type="text" class="form-control" bind:value={messageItem.message.text.value} on:input={() => debounceSaveMessage(messageItem)} readonly={isSaving}>
                <Button type="button" color="danger" on:click={() => removeMessage(messageItem)} disabled={isSaving}>
                    {#if isSaving}
                        <Spinner size="sm" />
                    {:else}
                        <Icon name="x" />
                    {/if}
                </Button>
            </div>
        </Watch>
    {/each}
</div>

<Button type="button" color="primary" size="sm" on:click={addMessage}>
    {$i18n("Añadir mensaje")}
</Button>

<style lang="scss">

    .messages {
        display: flex;
        flex-direction: column;
        gap: 1rem;
        margin-bottom: 1rem;
    }

    .input-group {
        max-width: 460px;
    }

</style>
